(function () {
  if (window.__naylumiCartSyncLoaded) return;
  window.__naylumiCartSyncLoaded = true;

  let syncTimer = null;

  function setText(el, count) {
    if (!el) return;
    if (el === document.documentElement || el === document.body) return;
    if (el.tagName === 'HTML' || el.tagName === 'BODY') return;
    el.textContent = String(count);
  }

  function setBubbleVisibility(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
      if (count > 0) {
        bubble.hidden = false;
        bubble.classList.remove('hidden', 'visually-hidden');
        bubble.style.display = '';
      } else {
        bubble.hidden = true;
        bubble.classList.add('hidden');
      }
    });
  }

  async function syncNow() {
    try {
      var response = await fetch('/cart.js', {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      var cart = await response.json();
      var count = Number(cart.item_count) || 0;

      document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
        setText(el, count);
      });

      document.querySelectorAll('.theme-drawer__badge').forEach(function (el) {
        setText(el, count);
      });

      document.querySelectorAll('[ref="cartItemCount"], [data-cart-count], [data-cart-drawer-count]').forEach(function (el) {
        setText(el, count);
      });

      setBubbleVisibility(count);

      window.__naylumiLastCartCount = count;

      return cart;
    } catch (error) {
      console.warn('[Naylumi cart sync] Error:', error);
      return null;
    }
  }

  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncNow, delay || 80);
    setTimeout(syncNow, 350);
    setTimeout(syncNow, 900);
  }

  window.naylumiSyncCartCounters = syncNow;
  window.naylumiScheduleCartSync = scheduleSync;

  [
    'shopify:cart:lines-update',
    'cart:updated',
    'cart:update',
    'cartUpdate',
    'cart-lines-update'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, function () {
      scheduleSync(60);
    });
  });

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;

      if (
        target.closest('cart-drawer') ||
        target.closest('#cart-drawer') ||
        target.closest('.cart-drawer') ||
        target.closest('.theme-drawer') ||
        target.closest('cart-items-component') ||
        target.closest('cart-remove-button') ||
        target.closest('quantity-selector-component') ||
        target.closest('button[name="plus"]') ||
        target.closest('button[name="minus"]') ||
        target.closest('button[name="remove"]') ||
        target.closest('[href*="/cart/change"]') ||
        target.closest('product-form') ||
        target.closest('button[name="add"]') ||
        target.closest('button[type="submit"]')
      ) {
        scheduleSync(150);
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleSync(50);
    });
  } else {
    scheduleSync(50);
  }
})();

/* ==========================================================================
   NAYLUMI — CHATBOT (agregado 28 ago 2026)

   POR QUE ESTA ACA Y NO EN theme.liquid:
   El script del widget vivia en layout/theme.liquid del tema "Copia de
   Horizon". Al publicar "Naylumi-Mariposa-Claude" el chat desaparecio
   (auditoria 24 ago 2026), y volvio a pasar al publicar "Naylumi-Fotos-Fix".
   Cada tema nuevo nacia sin la linea.

   Este archivo es un asset propio de Naylumi que ya viaja en cada duplicado
   del tema, asi que el chatbot sobrevive los cambios de tema publicado.

   Bot: Cloudflare Worker "forja-starter". Si el chat vuelve a desaparecer,
   lo primero es abrir la URL de abajo en el navegador: si responde
   JavaScript, el bot esta sano y el problema es la tienda otra vez.

   Para quitarlo: borrar este bloque completo.
   ========================================================================== */
(function () {
  if (window.__naylumiChatbotLoaded) return;
  window.__naylumiChatbotLoaded = true;

  function cargarChatbot() {
    if (document.getElementById('naylumi-chatbot')) return;
    var s = document.createElement('script');
    s.id = 'naylumi-chatbot';
    s.src = 'https://forja-starter-9ac567.pjgarcia01000.workers.dev/widget.js';
    s.async = true;
    s.onerror = function () {
      console.warn('[Naylumi] No se pudo cargar el chatbot.');
    };
    (document.body || document.head).appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cargarChatbot);
  } else {
    cargarChatbot();
  }
})();
